import { CollectionName } from '@/shared/lib/sj-orm/constants';
import { getCollectionDtoIdPrefix } from '@/shared/lib/sj-orm/helpers';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import {
  PersonalIdentifierDocumentDto,
  PersonalIdentifierType,
} from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';
import {
  PrivateDocumentCategory,
  PrivateDocumentDto,
} from '@/shared/lib/sj-orm/models/document/private.document.dto';
/**
 *  @deprecated Use src/entities/privateDocuments/hooks/useI18nValues.ts
 */
export const PrivateDocumentCategoryToText: Record<PrivateDocumentCategory, string> = {
  [PrivateDocumentCategory.PRIVATE_AGREEMENTS]:
    'documents:enums.privateDocCategory.privateAgreements',
  [PrivateDocumentCategory.PUBLIC_AGREEMENTS]:
    'documents:enums.privateDocCategory.publicAgreements',
  [PrivateDocumentCategory.INFORMATION_SHEETS]:
    'documents:enums.privateDocCategory.informationSheets',
  [PrivateDocumentCategory.BANK_DOCUMENTS]: 'documents:enums.privateDocCategory.bankDocuments',
  [PrivateDocumentCategory.PAYMENT_DOCUMENTS]:
    'documents:enums.privateDocCategory.paymentDocuments',
  [PrivateDocumentCategory.POWERS]: 'documents:enums.privateDocCategory.powers',
  [PrivateDocumentCategory.CORPORATE_DOCUMENTS]:
    'documents:enums.privateDocCategory.corporateDocuments',
  [PrivateDocumentCategory.FAMILY_DOCUMENTS]: 'documents:enums.privateDocCategory.familyDocuments',
  [PrivateDocumentCategory.OTHER]: 'documents:enums.privateDocCategory.other',
};

export const privateDocumentsCategoryI18nMap: Record<PrivateDocumentCategory, string> = {
  [PrivateDocumentCategory.PRIVATE_AGREEMENTS]: 'privateAgreements',
  [PrivateDocumentCategory.PUBLIC_AGREEMENTS]: 'publicAgreements',
  [PrivateDocumentCategory.INFORMATION_SHEETS]: 'informationSheets',
  [PrivateDocumentCategory.BANK_DOCUMENTS]: 'bankDocuments',
  [PrivateDocumentCategory.PAYMENT_DOCUMENTS]: 'paymentDocuments',
  [PrivateDocumentCategory.POWERS]: 'powers',
  [PrivateDocumentCategory.CORPORATE_DOCUMENTS]: 'corporateDocuments',
  [PrivateDocumentCategory.FAMILY_DOCUMENTS]: 'familyDocuments',
  [PrivateDocumentCategory.OTHER]: 'other',
};

export const isPersonalIdentifier = (type: string) =>
  [
    PersonalIdentifierType.DRIVER_LICENSE,
    PersonalIdentifierType.PASSPORT,
    PersonalIdentifierType.BIRTH_CERTIFICATE,
    PersonalIdentifierType.EDUCATION,
    PersonalIdentifierType.FREE_BLOCK,
    PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE,
    PersonalIdentifierType.MEDICAL_ID,
    PersonalIdentifierType.MILITARY_ID,
    PersonalIdentifierType.NATIONAL_ID,
    PersonalIdentifierType.RESIDENCE_PERMIT,
    PersonalIdentifierType.SOCIAL_SECURITY,
    PersonalIdentifierType.SUBSTANCE,
    PersonalIdentifierType.TAX_ID,
  ].includes(type as PersonalIdentifierType);

export const isPersonalIdentifierDocumentDtoId = (id: DtoId) => {
  return id.startsWith(getCollectionDtoIdPrefix(CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS));
};

export const isPersonalIdentifierDocumentDto = (dto: {
  id: DtoId;
}): dto is PersonalIdentifierDocumentDto => {
  return 'id' in dto && typeof dto.id === 'string' && isPersonalIdentifierDocumentDtoId(dto.id);
};

export const isPrivateDocumentDtoId = (id: DtoId) => {
  return id.startsWith(getCollectionDtoIdPrefix(CollectionName.PRIVATE_DOCUMENTS));
};

export const isPrivateDocumentDto = (dto: { id: DtoId }): dto is PrivateDocumentDto => {
  return 'id' in dto && typeof dto.id === 'string' && isPrivateDocumentDtoId(dto.id);
};

export const isPrivateDocumentCategory = (category: string): category is PrivateDocumentCategory =>
  Object.values(PrivateDocumentCategory).includes(category as PrivateDocumentCategory);

export const PD_FIELDS_WITH_ENTITIES_IDS = new Set(['attachments', 'signatories']);
